import React from "react";
import HighlightBlock from "../components/HighlightBlock";

import aboutImg from "../assets/img/urla/1/f9.jpg";

export default function AboutPage() {
    return (
        <main className="about-main">
            <section>
                <div className="container">
                    <HighlightBlock bgLabel="HCP YAPI" calligraphy="Hakkımızda">
                        <div className="row align-items-center about-hero-inner gx-5">
                            <div className="col-lg-6 mb-4 mb-lg-0 about-hero-img">
                                <img
                                    src={aboutImg}
                                    alt="HCP Yapı"
                                    className="img-fluid rounded shadow"
                                    style={{ minHeight: 260, objectFit: "cover", width: "100%" }}
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="about-hero-desc mb-3">
                                    <strong>Bornova Green</strong> ve <strong>Karşıyaka Green</strong> gibi öne çıkan projelerle dikkat çeken HCP Yapı, daha önceki projelerinden aldığı tecrübe ile, yepyeni konut projelerini sizlere sunmanın mutluluğunu yaşıyor.
                                </div>
                                <div>
                                    Aynı zamanda mimarlık-mühendislik firması olan HCP Yapı, sizlere, modern çağın ilerisine geçen projeleri sunmaya devam edecektir.
                                </div>
                            </div>
                        </div>
                    </HighlightBlock>
                </div>
            </section>
        </main>
    );
}
